import FormField from '../swedish-private-v2/form-field';

export const AutoFilledPersonalDetails = (props) => {
    const { form } = props;
    return (
        <FormField
            type="text"
            containerClassName="mb-2"
            form={form}
            field="PhoneNumber"
            placeholder="Ditt mobilnummer"
            hint="Ditt telefonnummer behövs ifall du skulle behöva återställa ditt lösenord."
        />
    );
};
